<template>
  <div class="background">
    <article class="leaderboard">
      <header>
        <h1 class="leaderboard__title"><span class="leaderboard__title--top">日常任务</span>
          <span class="leaderboard__title--bottom">每天需要做的事情</span></h1>
      </header>

      <div class="leaderboard__profiles">

        <article class="leaderboard__profile" v-for="item in workList" :key="item.title">
          <span class="leaderboard__name">{{ item.title }}</span>
          <span :class="'leaderboard__value '+ item.color" @click="times(item.title, item.color)">开始</span>
        </article>

        <article class="leaderboard__profile">
          <!--img src="https://www.jq22.com/tp/6372812586954117362846160.png" alt="Evan Spiegel" class="leaderboard__picture"-->
          <span class="leaderboard__name">+</span>
        </article>
      </div>
    </article>
    <article class="leaderboard">
      <header>
        <h1 class="leaderboard__title"><span class="leaderboard__title--top">主线任务</span>
          <span class="leaderboard__title--bottom">人生终极目标</span></h1>
      </header>

      <div class="leaderboard__profiles">
        <article class="leaderboard__profile">
          <span class="leaderboard__name">找工作</span>
          <span class="'leaderboard__value green" @click="longTime('找工作')">主线任务，进度：100%</span>
        </article>
        <article class="leaderboard__profile">
          <span class="leaderboard__name">学识和口才</span>
          <span class="'leaderboard__value green" @click="longTime('学识和口才')">自身的技术和口述能力</span>
        </article>
        <article class="leaderboard__profile">
          <span class="leaderboard__name">外快</span>
          <span class="'leaderboard__value green" @click="longTime('外快')">主线任务，每月：2000</span>
        </article>
        <article class="leaderboard__profile">
          <span class="leaderboard__name">身体健康</span>
          <span class="'leaderboard__value green" @click="longTime('身体健康')">运动，减少难受保持清醒</span>
        </article>
        <article class="leaderboard__profile">
          <span class="leaderboard__name">乐于沟通</span>
          <span class="'leaderboard__value green" @click="longTime('乐于沟通')">家人朋友同事时事</span>
        </article>
        <article class="leaderboard__profile">
          <span class="leaderboard__name">自己的系统</span>
          <span class="'leaderboard__value green" @click="longTime('海神与明月')">H5/U3T/BLOG/GOC6</span>
        </article>
        <article class="leaderboard__profile">
          <span class="leaderboard__name">旅游打卡</span>
          <span class="'leaderboard__value green" @click="longTime('旅游打卡')">北京和其他地方的打卡记录</span>
        </article>
        <article class="leaderboard__profile">
          <span class="leaderboard__name">车/房/等</span>
          <span class="'leaderboard__value green" @click="longTime('车/房')">家庭大件开支</span>
        </article>
        <article class="leaderboard__profile">
          <span class="leaderboard__name">整洁和形象</span>
          <span class="'leaderboard__value green" @click="longTime('轻薄的假象')">想象和能力等</span>
        </article>

        <article class="leaderboard__profile">
          <!--img src="https://www.jq22.com/tp/6372812586954117362846160.png" alt="Evan Spiegel" class="leaderboard__picture"-->
          <span class="leaderboard__name">+</span>
        </article>
      </div>
    </article>
  </div>
</template>

<script>

export default {
  name: 'Work',
  data() {
    return {
      baseUrl: 'http://goc6.com',
      fromTime: new Date(new Date().toLocaleDateString()).getTime(),
      score: 100,
      workList: []
    }
  },
  mounted() {
    this.inits();
  },
  methods: {
    inits() {
      const url = this.baseUrl + "/front/task/list";
      let that = this;
      this.$axios.get(url, {}).then(function (response) {
        that.workList = response.data || [];
      })
    },
    times(title, color) {
      if (title.length === 0) {
        alert("请返回首页输入名字");
      } else {
        if (!localStorage.getItem("caches") || confirm('存在正在运行的事件，确定后将自动结束上个事件，计时新的事件？')) {
          localStorage.setItem("title", title);
          localStorage.setItem("color", color);
          window.location.href = "/time";
        }
      }
    },
    longTime(title) {
      if (title.length === 0) {
        alert("请返回首页输入名字");
      } else {
        localStorage.setItem("longTime", title);
        window.location.href = "/time";
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
html, body {
  height: 100%;
  width: 100%;
  Font-size: 25%
}

body {
  margin: 0;
  background-color: #eaeaea;
  display: grid;
  height: 100vh;
  place-items: center;
  font-family: 'Source Sans Pro', sans-serif;
}

.background {
  /*background-image: url("https://t7.baidu.com/it/u=1297102096,3476971300&fm=193&f=GIF");*/
  height: 100%;
  width: 100%;
  background-size: cover;
  position: absolute;
  text-align: center;
}

.leaderboard {
  float: left;
  width: 90%;
  top: 5%;
  left: 5%;
  max-width: 490px;
  border-radius: 12px;
}

.leaderboard header {
  --start: 15%;
  height: 130px;
  background-image: repeating-radial-gradient(circle at var(--start), transparent 0%, transparent 10%, rgba(54, 89, 219, 0.33) 10%, rgba(54, 89, 219, 0.33) 17%), linear-gradient(to right, #5b7cfa, #3659db);
  color: #fff;
  position: relative;
  border-radius: 12px 12px 0 0;
  overflow: hidden;
}

.leaderboard header .leaderboard__title {
  position: absolute;
  z-index: 2;
  top: 50%;
  right: calc(var(--start) * .75);
  transform: translateY(-50%);
  text-transform: uppercase;
  margin: 0;
}

.leaderboard header .leaderboard__title span {
  display: block;
}

.leaderboard header .leaderboard__title--top {
  font-size: 24px;
  font-weight: 700;
  letter-spacing: 6.5px;
}

.leaderboard header .leaderboard__title--bottom {
  font-size: 13px;
  font-weight: 500;
  letter-spacing: 3.55px;
  opacity: .65;
  transform: translateY(-2px);
}

.leaderboard header .leaderboard__icon {
  fill: #fff;
  opacity: .35;
  width: 50px;
  position: absolute;
  top: 50%;
  left: var(--start);
  transform: translate(-50%, -50%);
}

.leaderboard__profiles {
  background-color: #fff;
  border-radius: 0 0 12px 12px;
  padding: 15px 15px 20px;
  display: grid;
  row-gap: 8px;
}

.leaderboard__profile {
  display: grid;
  grid-template-columns: 1fr 3fr 1fr;
  align-items: center;
  padding: 10px 30px 10px 10px;
  overflow: hidden;
  border-radius: 10px;
  box-shadow: 0 5px 7px -1px rgba(51, 51, 51, 0.23);
  cursor: pointer;
  transition: transform 0.25s cubic-bezier(0.7, 0.98, 0.86, 0.98), box-shadow 0.25s cubic-bezier(0.7, 0.98, 0.86, 0.98);
  background-color: #fff;
}

.leaderboard__profile:hover {
  transform: scale(1.2);
  box-shadow: 0 9px 47px 11px rgba(51, 51, 51, 0.18);
}

.leaderboard__picture {
  max-width: 100%;
  width: 60px;
  border-radius: 50%;
  box-shadow: 0 0 0 10px #ebeef3, 0 0 0 22px #f3f4f6;
}

.leaderboard__name {
  width: 100px;
  color: #979cb0;
  font-weight: 600;
  font-size: 20px;
  margin-left: 12px;
}

.leaderboard__value {
  /*color: #35d8ac;*/
  font-weight: 700;
  font-size: 20px;
  text-align: right;
}

.green {
  color: #72b362;
}

.blue {
  color: #7b9ce1;
}

.red {
  color: #bd6d6c;
}

.leaderboard__value > span {
  opacity: .8;
  font-weight: 600;
  font-size: 20px;
  margin-left: 3px;
}


.leaderboard {
  box-shadow: 0 0 40px -10px rgba(0, 0, 0, 0.4);
}

</style>



// WEBPACK FOOTER //
// src/components/game/Work.vue